import { Reducer } from "redux";

import { SET_USER, SET_USER_ACCESS } from "./types";
import { UserStore } from "../../../types/ReduxTypes/StoreTypes";

const initialState: UserStore = {
  currentUser: "",
  role: "user",
  isAdmin: false,
  canManageRoles: false,
  isRoleLoaded: false,
};

const userReducer: Reducer<UserStore> = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, currentUser: action.payload };
    case SET_USER_ACCESS:
      return {
        ...state,
        role: action.payload.role,
        isAdmin: action.payload.isAdmin,
        canManageRoles: Boolean(action.payload.canManageRoles),
        isRoleLoaded: true,
      };
    default:
      return state;
  }
};

export default userReducer;
